import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container mb-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Alterar Dados da Notificação ")
const _hoisted_3 = { class: "pt-3 pb-2 mb-3 border-bottom" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Descrição", -1)
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Titulo", -1)
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Texto", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "URL (Link que vai ser aberto ao clicar na msg)", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Tag", -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Logo . Ex: https://seudominio/folder/img.png ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary mb-3" }, "Salvar", -1)
const _hoisted_17 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_18 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_19 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, [
      _hoisted_2,
      _createVNode(_component_font_awesome_icon, { icon: "bell" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "btn btn-sm btn-outline-secondary",
        title: "Voltar sem Salvar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.voltar()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "arrow-circle-left" })
      ])
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.descricao) = $event)),
          class: "form-control",
          name: "descricao",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.descricao]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.title) = $event)),
          class: "form-control",
          name: "title",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.title]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.mensagem) = $event)),
          class: "form-control",
          name: "mensagem",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.mensagem]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.url) = $event)),
          class: "form-control",
          name: "url",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.url]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.tag) = $event)),
          class: "form-control",
          name: "tag",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.tag]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.imglogo) = $event)),
          class: "form-control",
          name: "imglogo",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.imglogo]
        ])
      ]),
      _hoisted_16,
      ($setup.data.msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            ($setup.data.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true),
            ($setup.data.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}